import { render, staticRenderFns } from "./ia-sparkline.vue?vue&type=template&id=2547af3c&scoped=true&"
import script from "./ia-sparkline.vue?vue&type=script&lang=js&"
export * from "./ia-sparkline.vue?vue&type=script&lang=js&"
import style0 from "./ia-sparkline.vue?vue&type=style&index=0&id=2547af3c&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2547af3c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2547af3c')) {
      api.createRecord('2547af3c', component.options)
    } else {
      api.reload('2547af3c', component.options)
    }
    module.hot.accept("./ia-sparkline.vue?vue&type=template&id=2547af3c&scoped=true&", function () {
      api.rerender('2547af3c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/aawz-intelligence-v2/components/ia-insight-card/ia-sparkline.vue"
export default component.exports